import React, { useEffect, useState } from "react";
import { useParams,  Link  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import HorizontalSlider from "../components/HorizontalSlider.js";
import "../styles/NewsArticlePage.css";
import { getUserLanguage } from "../utils.js";

import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.js"; // Ensure this path is correct in your project

const stripHtmlTags = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || "";
};

const NewsArticlePage = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [article, setArticle] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [relatedArticles, setRelatedArticles] = useState([]);
  const [error, setError] = useState(null);

  const userIsAdmin = true; // Placeholder: Replace with your own admin check logic


  useEffect(() => {
    const fetchArticleData = async () => {
      const userLanguage = getUserLanguage();

      try {
        let articleData = null;
        let docRef = null;

        // Check if id is a Firestore document ID (string) or numeric id
        if (isNaN(id)) {
          // If id is not a number, treat it as a Firestore document ID
          try {
            const docRef = doc(db, "news", id);
            const docSnapshot = await getDoc(docRef);
            
            if (docSnapshot.exists()) {
              articleData = docSnapshot.data();
              setArticle({ docId: docSnapshot.id, refId: docSnapshot.ref.id, ...articleData });
              console.log("Document found by Firestore ID:", docSnapshot.ref.id);
            }
          } catch (error) {
            console.error("Error fetching by document ID:", error);
          }
        } else {
          // If id is a number, query by the numeric 'id' field
          const articleId = parseInt(id, 10);
          const articleQuery = query(
            collection(db, "news"),
            where("id", "==", articleId)
          );
          const articleSnapshot = await getDocs(articleQuery);

          if (!articleSnapshot.empty) {
            const doc = articleSnapshot.docs[0];
            articleData = doc.data();
            docRef = doc;
            setArticle({ docId: doc.id, refId: doc.ref.id, ...articleData });
            console.log("Document found by numeric ID:", doc.ref.id);
          }
        }

        if (articleData) {
          if (
            articleData.productCategories &&
            articleData.productCategories.length > 0
          ) {
            // Fetch related products
            const productsQuery = query(
              collection(db, "products"),
              where("language", "==", userLanguage),
              where(
                "categories",
                "array-contains-any",
                articleData.productCategories
              )
            );
            const productsSnapshot = await getDocs(productsQuery);
            const products = [];
            productsSnapshot.forEach((doc) => {
              products.push({ id: doc.id, ...doc.data() });
            });
            setRelatedProducts(products);

            // Fetch related articles
            const relatedArticlesQuery = query(
              collection(db, "news"),
              where("language", "==", userLanguage),
              where(
                "productCategories",
                "array-contains-any",
                articleData.productCategories
              )
            );
            const relatedArticlesSnapshot = await getDocs(relatedArticlesQuery);
            const related = [];
            relatedArticlesSnapshot.forEach((doc) => {
              const data = doc.data();
              if (data.id !== articleData.id) {
                related.push({ id: data.id, ...data });
              }
            });
            setRelatedArticles(related);
          }
        } else {
          console.error("Article not found");
          setError(t("newsArticlePage.articleNotFound"));
        }
      } catch (error) {
        console.error("Error fetching article data:", error);
        setError(t("newsArticlePage.errorFetchingArticle"));
      }
    };

    fetchArticleData();
  }, [id, t]);

  if (error) {
    return <div>{error}</div>;
  }

  if (!article) {
    return <div>{t("newsArticlePage.loading")}</div>;
  }

  const plainTextContent = stripHtmlTags(article.content);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: article.title,
    image: article.image,
    datePublished: article.date,
    author: {
      "@type": "Person",
      name: article.author || "Unknown",
    },
    keywords: article.keywords ? article.keywords.join(", ") : "",
    articleBody: plainTextContent,
  };

  return (
    <div className="news-article-page">
      <Helmet>
        <title>{article.title}</title>
        <meta
          name="description"
          content={plainTextContent.substring(0, 150)}
        />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      <h1>{article.title}</h1>
      <div className="news-article-meta">
        <p className="news-article-date">
          {new Date(article.date).toLocaleDateString()}
        </p>
        {article.author && (
          <p className="news-article-author">
            {t("newsArticlePage.author")}: {article.author}
          </p>
        )}
      </div>
      <img
        src={article.image}
        alt={article.title}
        className="news-article-image"
      />
      <div dangerouslySetInnerHTML={{ __html: article.content }} />
      {userIsAdmin && (
        <div className="edit-button-container">
          <Link to={`/articles/edit/${article.refId}`} className="edit-button">
            {t("newsArticlePage.editArticle")}
          </Link>
        </div>
      )}
           <section
        className="enem-training-cta"
        aria-label="Treinamento ENEM com IA"
        style={{
          marginTop: 32,
          marginBottom: 24,
          borderRadius: 12,
          padding: "28px 24px",
          background:
            "linear-gradient(135deg, rgba(102,126,234,0.12) 0%, rgba(118,75,162,0.12) 100%)",
          border: "1px solid rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            display: "grid",
            gap: 14,
            alignItems: "center",
          }}
        >
          <h2 style={{ margin: 0, fontWeight: 800, fontSize: "1.6rem", color: "#2b2d42" }}>
            🎯 Quer treinar redação para o ENEM com correção por IA?
          </h2>
          <p style={{ margin: 0, color: "#4a4e69", lineHeight: 1.5 }}>
            Pratique temas reais, receba feedback instantâneo e melhore sua nota. Comece agora mesmo no YouSmart!
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 6 }}>
            <Link
              to="/"
              className="enem-cta-button"
              style={{
                background: "#4f46e5",
                color: "#fff",
                padding: "12px 18px",
                borderRadius: 8,
                fontWeight: 700,
                textDecoration: "none",
                display: "inline-block",
              }}
              aria-label="Ir para a página inicial do YouSmart"
            >
              Acessar YouSmart
            </Link>
            <Link
              to="/enem-training"
              className="enem-cta-secondary"
              style={{
                background: "#ffffff",
                color: "#4f46e5",
                padding: "12px 18px",
                borderRadius: 8,
                fontWeight: 700,
                textDecoration: "none",
                border: "2px solid #4f46e5",
                display: "inline-block",
              }}
              aria-label="Ir para o Treinamento ENEM"
            >
              Ver Treinamento ENEM
            </Link>
          </div>
        </div>
      </section>

      {relatedProducts.length > 0 && (
        <section className="related-products-section">
          <h2>{t("newsArticlePage.relatedProducts")}</h2>
          <HorizontalSlider products={relatedProducts} />
        </section>
      )}

      {relatedArticles.length > 0 && (
        <section className="related-articles-section">
          <h2>{t("newsArticlePage.relatedArticles")}</h2>
          <div className="related-articles-grid">
            {relatedArticles.map((relatedArticle) => (
              <div key={relatedArticle.id} className="related-article-card">
                <a href={`/news/${relatedArticle.id}`}>
                  <img
                    src={relatedArticle.image}
                    alt={relatedArticle.title}
                    className="related-article-image"
                  />
                  <h3>{relatedArticle.title}</h3>
                </a>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};


export default NewsArticlePage;
